module.exports = __webpack_public_path__ + "static/media/1920-service-1-2-min.498e7686.jpg";